module.exports = __webpack_public_path__ + "static/media/8OLA27.ff655347.jpg";